/* eslint-disable max-len */
import React, { memo, Fragment } from 'react'
import classNames from 'classnames'
import Player from 'root/src/client/web/base/Player'
import useScript from 'root/src/client/web/hooks/useScript'
import {
	ytPlayerSrc,
	twitchPlayerSrc,
	facebookPlayerSrc,
	tiktokPlayerSrc,
} from 'root/src/shared/constants/playerUrls'

const DareVideo = (({ classes, DareDetails, projectDeliveries }) => {
	const [ytLoaded] = useScript(ytPlayerSrc)
	const [twitchPlayerLoaded] = useScript(twitchPlayerSrc)
	const [facebookPlayerLoaded] = useScript(facebookPlayerSrc)
	const [tiktokPlayerLoaded] = useScript(tiktokPlayerSrc)
	const isTwitterStatus = projectDeliveries.platform === 'twitter'
	return (
		<section
			className={classNames('flex layout-row layout-align-space-between', classes.dareCardRoot)}
			style={isTwitterStatus ? { height: 'auto' } : {}}
		>
			<div className={classNames(classes.completedDareDetailsContent,
				'flex layout-column layout-align-space-between')}
			>
				<div className="flex layout-row layout-align-space-between">
					<div className="flex layout-column layout-align-start">
						<DareDetails />
					</div>
				</div>
			</div>
			{ytLoaded && twitchPlayerLoaded && facebookPlayerLoaded && tiktokPlayerLoaded
				&& (
					<Player
						completedDare
						projectDeliveries={projectDeliveries}
						autoplay
						className={classes.player}
						isViewProjectPage
					/>
				)
			}
		</section>
	)
})

export default memo(({ classes, isMobileRes, DareDetails, projectDeliveries, DareDetailButtonSet, DareDetailIconSet }) => (
	<Fragment>
		<div className={classes.completeDareTitle}>Completed Dare</div>
		<DareVideo {...{ classes, DareDetails, projectDeliveries }} />
		<div className={classes.completedDareButton}>
			<div className={classNames(classes.actionButtonSet, 'flex layout-row layout-align-space-between')}>
				<DareDetailButtonSet />
				{!isMobileRes && <DareDetailIconSet />}
			</div>
		</div>
	</Fragment>
))
